import axios from 'axios'
import { AccessToken } from '../../../utils/authUtils'

export type IsMultimarketResponse = {
  is_multimarket: boolean
}

export const fetchIsMultimarket = async (
  surveyId: string
): Promise<IsMultimarketResponse> => {
  const response = await axios.get<IsMultimarketResponse>(
    `${process.env.REACT_APP_REST_DOMAIN}/v1/core-responses/multimarket/surveys/${surveyId}/is-multimarket`,
    {
      headers: {
        ...AccessToken.requestHeaders()
      }
    }
  )
  return response.data
}
